//import { Queries } from "../services/queries";
import {IActiveOrder} from "../components/contracts/types";

import React, {useEffect, useState } from "react";
import { useRouter } from "next/router";


import MenuComponent from '../components/menu';

import Head from 'next/head'

import CartTable from  '../components/cart'
import Checkoutnavi from "../components/checkoutnavi";
import User from "../components/user";


import { useMutation, useQuery } from "@apollo/client";
import { CartQuery } from "../queries/get_cart";
import { removeOrderLineMutation } from "../queries/remove-from-cart.mutation";
import { changeCartLineMutation }  from "../queries/change-cart-line";
import { Queries } from "../services/queries";
import {WEBSERVER} from "../services/globals"

const base = WEBSERVER;



const MyCartPage = ({editable=true}) => {
    const [activeOrder, setActiveOrder] = useState<IActiveOrder | null>(null);
    const { data, loading, error, refetch } = useQuery<IActiveOrder>(CartQuery);
    
   const [change, { error: cError, loading: cLoading }] = useMutation(
      changeCartLineMutation
    );

    const [remove, { error: rError, loading: rLoading }] = useMutation(
      removeOrderLineMutation
    );
 
    const router = useRouter();
  
    useEffect(() => {
      data?.activeOrder && setActiveOrder(data);
    }, [data]);
  
    useEffect(() => {
      refetch();
    }, [router.events]);

    const changeCartLine = (id: number , qty :number ) => {
      change({ variables: { id, qty } });
      setTimeout(() => {refetch()},200);
      //alert("change cart line " + id + "  " + qty);
    };

    const setLineQuantity = (id:number, value:number) => {
       setActiveOrder(currentdata => {
        let datacopy = JSON.parse(JSON.stringify(data));
        datacopy.activeOrder.lines.map(line =>  { 
          if (line.id === id) {
              line.quantity = value;
          }
        })
        return datacopy;
        })  
      };

    const removeItemFromOrder = (id: number) => {
      remove({ variables: { id } });
      setTimeout(() => {refetch()},200);
      //refetch();
    };

    //console.log(JSON.stringify(activeOrder)) ;


    return (<div>
        <Head>
          <title>Warenkorb</title>
        </Head>

        <div className="container-fluid">
        <div className="flex-row-reverse">
              <User></User>
      </div>

        {!loading && !error && (
            <div>
            {editable?
            <div> 
            <Checkoutnavi step="0"></Checkoutnavi>
            </div>
            :
            <div></div>
            }

            <div className="table-responsive">
            <CartTable
              activeOrder={activeOrder}
              removeItemFromOrder={removeItemFromOrder}
              changeCartLine={changeCartLine}
              setLineQuantity={setLineQuantity}
              editable={editable}
            />
           </div>
           </div>
        )}
        </div>
    </div>);
  };
  
export default MyCartPage;
  


